<template>
  <el-dialog
    :visible="true"
    :before-close="handleClose"
    :title="'设置' | translateTo(i18nPath)"
    :width="isEnglish ? '65vw' : '55vw'"
    top="10vh"
    class="rg05-setting"
  >
    <el-form
      ref="form"
      v-loading="loading"
      :element-loading-text="'加载中' | translateTo(i18nPath)"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :model="data"
      :rules="rules"
      :label-width="isEnglish ? '280px' : '180px'"
      :inline="true"
    >
      <el-row type="flex">
        <el-col :span="12">
          <el-form-item :label="'软件版本' | translateTo(i18nPath)">
            <el-input :value="swVer || '--'" disabled placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'WiFi连接状态' | translateTo(i18nPath)">
            <span class="iconfont icon-net-4g" :class="{ active: connection4GStatus }"></span>
            <span class="iconfont icon-wifi" :class="{ active: wifiConnectionStatus }"></span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'sim卡号' | translateTo(i18nPath)">
            <el-input :value="simNumber || '--'" disabled placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'硬件版本' | translateTo(i18nPath)">
            <el-input :value="hwVer || '--'" disabled placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'核报警阈值' | translateTo(i18nPath)" prop="setAlarmThresh">
            <el-input v-model="data.setAlarmThresh"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'蜂鸣器音量' | translateTo(i18nPath)" prop="setBuzzVol">
            <el-radio-group v-model="data.setBuzzVol">
              <el-radio
                v-for="(item, index) in buzzVolOptions"
                :key="`buzz-${index}`"
                :label="item.value"
              >
                {{ item.label | translateTo(i18nPath) }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'光栅主从模式' | translateTo(i18nPath)" prop="setGratingMode">
            <el-radio-group v-model="data.setGratingMode">
              <el-radio
                v-for="(item, index) in gratingModeOptions"
                :key="`grating-mode-${index}`"
                :label="item.value"
              >
                {{ item.label | translateTo(i18nPath) }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'低电量报警' | translateTo(i18nPath)">
            <el-radio-group v-model="data.setBattAlarm">
              <el-radio
                v-for="(item, index) in battAlarmOptions"
                :key="`alarm-${index}`"
                :label="item.value"
              >
                {{ item.label | translateTo(i18nPath) }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'报警方式' | translateTo(i18nPath)" prop="deviceAlarmMode">
            <el-radio-group v-model="data.setDeviceAlarmMode">
              <el-radio
                v-for="(item, index) in deviceAlarmModeOptions"
                :key="`alarm-${index}`"
                :label="item.value"
              >
                {{ item.label | translateTo(i18nPath) }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            v-if="data.setDeviceAlarmMode === 0"
            :label="'报警状态' | translateTo(i18nPath)"
            prop="deviceAlarmState"
          >
            <el-radio-group v-model="data.setDeviceAlarmStatus">
              <el-radio
                v-for="(item, index) in deviceAlarmStateOptions"
                :key="`alarm-${index}`"
                :label="item.value"
              >
                {{ item.label | translateTo(i18nPath) }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="'LED灯光-正常' | translateTo(i18nPath)" prop="setColorPlan">
            <el-color-picker size="small" v-model="ledNormalColor"></el-color-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="'LED灯光-报警' | translateTo(i18nPath)" prop="colorPlan">
            <el-color-picker size="small" v-model="ledWarnColor"></el-color-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="'LED灯光-故障' | translateTo(i18nPath)" prop="colorPlan">
            <el-color-picker size="small" v-model="ledAlarmColor"></el-color-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="'复位红外计数器' | translateTo(i18nPath)" prop="resetInfrared">
            <el-switch
              v-model="data.resetInfrared"
              active-color="#13ce66"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="'复位核报警次数计数器' | translateTo(i18nPath)" prop="resetAlarm">
            <el-switch
              v-model="data.resetAlarm"
              active-color="#13ce66"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="'复位核检测基线' | translateTo(i18nPath)" prop="resetBaseline">
            <el-switch
              v-model="data.resetBaseline"
              active-color="#13ce66"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="'LED亮度' | translateTo(i18nPath)" prop="setLedIntense">
            <el-slider v-model="data.setLedIntense" :min="0" :max="100" :step="1"></el-slider>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="'报警平滑时长' | translateTo(i18nPath)" prop="setAlarmSmooth">
            <el-slider v-model="data.setAlarmSmooth" :min="0" :max="10" :step="1"></el-slider>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="handler">
      <el-button
        class="confirm"
        type="primary"
        :disabled="loading"
        :loading="confirmLoading"
        @click="save"
      >
        {{ '确定' | translateTo(i18nPath) }}
      </el-button>
      <el-button class="cancel" @click="handleClose">
        {{ '取消' | translateTo(i18nPath) }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getDeviceStatus, paramSetting } from '@/api/deviceSetting';
import { isArray, isEmpty, isFunction, isObject, isString } from '@/utils/is';
import Color from 'color';
import { List } from '@/utils/List';
import { awaitTo } from '@/utils/utils';

var makeValidate = ({ min, max, msg }) => {
  const validator = (_, value, callback) => {
    if (value >= min && value <= max) {
      callback();
    } else {
      callback(new Error(msg));
    }
  };
  return { validator };
};

const common = {
  message: '请输入数值',
  validator(rule, value, callback) {
    if (/^\d+$/.test(value)) {
      callback();
    } else {
      callback(new Error(rule.message));
    }
  },
  trigger: 'blur'
};

export default {
  props: {
    sn: {
      type: String,
      default: ''
    },
    deviceType: {
      type: String,
      default: ''
    }
  },
  data() {
    const defaultColorPlan = [
      [0, 0, 254],
      [254, 0, 0],
      [254, 254, 0]
    ];
    return {
      i18nPath: 'layout',
      loading: false,
      confirmLoading: false,
      oldData: {},
      hwVer: '',
      swVer: '',
      wifiConnectionStatus: 0,
      connection4GStatus: 1,
      simNumber: '89860622330053003208',
      defaultColorPlan,
      gratingModeOptions: [
        { label: '从', value: 0 },
        { label: '主', value: 1 }
      ],
      buzzVolOptions: [
        { label: '低', value: 0 },
        { label: '中', value: 1 },
        { label: '高', value: 2 },
        { label: '关闭', value: 3 }
      ],
      deviceAlarmModeOptions: [
        { label: '受控', value: 0 },
        { label: '自动', value: 1 }
      ],
      deviceAlarmStateOptions: [
        { label: '不报警', value: 0 },
        { label: '报警', value: 1 }
      ],
      battAlarmOptions: [
        { label: '关闭', value: 0 },
        { label: '开启', value: 1 }
      ],
      data: {
        setAlarmThresh: 1,
        setBuzzVol: 1,
        setGratingMode: 0,
        setDeviceAlarmMode: 0,
        setDeviceAlarmStatus: 0,
        setLedIntense: 100,
        setBattAlarm: 1,
        setColorPlan: defaultColorPlan,
        resetInfrared: 0, //复位红外计数器
        resetAlarm: 0, //复位核报警次数计数器
        resetBaseline: 0, //复位核检测基线
        setAlarmSmooth: 0 // 设置报警平滑时长
      },
      rules: {
        setAlarmThresh: [
          {
            validator: (_, value, callback) => {
              const reg = /^0|1000$|^[1-9]\d{0,2}$|^(?:0\.\d|[1-9]\d{0,2}\.\d)$/;
              const reg2 = /^(0|1000|([1-9]\d{0,2}))$/;
              if (this.swVer && !reg2.test(value)) {
                let lastIndex = this.swVer.lastIndexOf('.');
                let subVer = this.swVer.slice(lastIndex + 1);
                if (lastIndex === 1 && subVer < 11) {
                  callback(new Error('请输入合法数值支持0 ~ 1000整数'));
                } else {
                  callback();
                }
              } else if (!reg.test(value)) {
                callback(new Error('请输入合法数值0 ~ 1000支持小数点后一位'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          },
          makeValidate({ min: 0, max: 1000, msg: '请正确填写报警阈值' })
        ],
        setBuzzVol: [common, makeValidate({ min: 0, max: 3, msg: '请正确填写蜂鸣器音量' })],
        setGratingMode: [common, makeValidate({ min: 0, max: 65536, msg: '请选择光栅主从模式' })],
        setDeviceAlarmMode: [
          common,
          makeValidate({ min: 100, max: 240, msg: '请设置设备报警状态' })
        ],
        setAlarmSmooth: [makeValidate({ min: 0, max: 10, msg: '报警平滑时长设置范围0~10' })]
      }
    };
  },
  computed: {
    ledNormalColor: {
      get() {
        return Color(this.data.setColorPlan[0]).string();
      },
      set(v) {
        this.data.setColorPlan.splice(0, 1, Color(v).array());
      }
    },
    ledWarnColor: {
      get() {
        return Color(this.data.setColorPlan[1]).string();
      },
      set(v) {
        this.data.setColorPlan.splice(1, 1, Color(v).array());
      }
    },
    ledAlarmColor: {
      get() {
        return Color(this.data.setColorPlan[2]).string();
      },
      set(v) {
        this.data.setColorPlan.splice(2, 1, Color(v).array());
      }
    }
  },
  methods: {
    handleClose(done) {
      this.$destroy();
      isFunction(done) && done();
    },
    getParams() {
      const keys = Object.keys(this.data);
      let o = null;
      let n = null;
      const map = keys.reduce((map, key) => {
        o = this.oldData[key];
        n = this.data[key];

        if (isObject(o) || isArray(o)) {
          if (JSON.stringify(o) !== JSON.stringify(n)) {
            map[key] = n;
          }
        } else {
          if (o !== n) {
            map[key] = n;
          }
        }
        return map;
      }, {});

      if (Reflect.has(map, 'setAlarmThresh')) {
        map.setAlarmThresh = parseFloat(map.setAlarmThresh).toString();
      }

      if (Reflect.has(map, 'setDeviceAlarmMode') || Reflect.has(map, 'setDeviceAlarmStatus')) {
        map.setDeviceAlarmMode = this.data.setDeviceAlarmMode;
        map.setDeviceAlarmStatus = this.data.setDeviceAlarmStatus;
      }

      if (Reflect.has(map, 'setColorPlan')) {
        map.setColorPlan = map.setColorPlan.flat(2).join(',');
      }

      return map;
    },
    clearLoading() {
      const timer = setTimeout(() => {
        this.loading = false;
        this.confirmLoading = false;
        clearTimeout(timer);
      }, 500);
    },
    getDeviceStatus() {
      this.loading = true;
      getDeviceStatus({ sn: this.sn, deviceType: this.deviceType, busiType: 1 })
        .then(res => {
          const { data } = res || {};
          const { config, mainHwVer, mainSwVer } = data;
          if (isEmpty(data) || isEmpty(config)) {
            this.$message.warning('获取设备配置失败');
            return;
          }
          this.hwVer = mainHwVer;
          this.swVer = mainSwVer;

          this.connection4GStatus = config.connection4GStatus;
          this.wifiConnectionStatus = config.wifiConnectionStatus;
          this.simNumber = config.simNumber;

          let colors = isString(config.colorPlan)
            ? List.groupByLength({ target: config.colorPlan.split(',').map(e => +e), length: 3 })
            : this.defaultColorPlan;

          Object.assign(this.data, {
            setAlarmThresh: config.alarmThresh,
            setBuzzVol: config.buzzVol,
            setGratingMode: config.gratingMode,
            setDeviceAlarmMode: config.deviceAlarmMode,
            setDeviceAlarmStatus: config.deviceAlarmStatus,
            setLedIntense: config.ledIntense,
            setBattAlarm: config.battAlarm,
            setColorPlan: colors,
            setAlarmSmooth: config.alarmSmooth
          });
          Object.assign(this.oldData, JSON.parse(JSON.stringify(this.data)));
        })
        .finally(this.clearLoading);
    },
    async save() {
      this.confirmLoading = true;

      const [err] = await awaitTo(this.$refs.form.validate());
      if (err === false) return (this.confirmLoading = false);

      const requestData = this.getParams();

      if (isEmpty(requestData)) {
        console.log('[RG05][SETTING]--无参数');
        this.clearLoading();
        this.handleClose();
        return;
      }

      paramSetting({
        sn: this.sn,
        deviceType: this.deviceType,
        requestData
      })
        .then(() => {
          this.$message.success('设置成功');
          this.handleClose();
        })
        .finally(this.clearLoading);
    }
  },
  created() {
    this.getDeviceStatus();
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.rg05-setting {
  .el-dialog {
    min-width: 900px;
  }

  .iconfont {
    color: #eee;
    margin-right: 10px;
    &.active {
      color: #2bff01;
    }
  }

  .el-row {
    &.el-row--flex {
      flex-wrap: wrap;
    }
    .el-col {
      overflow: hidden;
    }
  }

  .el-form {
    display: flex;
  }
  .el-form-item {
    display: flex;
    .el-form-item__label {
      &::after {
        content: '：';
      }
    }
    .el-form-item__content {
      flex: 1;
      display: flex;
      align-items: center;
      .el-input {
        width: 230px;
      }
      .unit {
        margin-left: 20px;
      }
    }
  }
  .el-slider {
    width: 90%;
    padding-left: 5px;
  }
  .handler {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    .confirm {
      margin-right: 20px;
    }
  }
}
</style>
